module.exports = __webpack_public_path__ + "img/10.ca344188.png";